import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { PageHero, Reveal } from "@/components/site/Reveal";
import { CtaButtons } from "@/components/site/Seo";
import { FormuleCard } from "@/pages/public/Formules";
import { api } from "@/lib/api";
import usePageMeta from "@/hooks/usePageMeta";

const CATALOGUE = [
  { h3: "Visite et contrôle", to: "/surveillance-maison-brest/", items: ["Visite de contrôle simple", "Aération et contrôle intérieur", "Contrôle visuel du logement", "Relevé de compteur extérieur", "Relève et réexpédition du courrier"] },
  { h3: "Accès, arrivées et départs", to: "/remise-cles-brest/", items: ["Préparation du logement avant une arrivée", "Fermeture du logement après un départ", "Remise et récupération de clés", "Accueil d'un artisan ou d'une livraison"] },
  { h3: "Entretien et linge", to: "/entretien-logement-brest/", items: ["Entretien studio / T1", "Entretien T2", "Entretien T3", "Entretien T4", "Nettoyage des vitres", "Nettoyage de terrasse et extérieurs", "Gestion du linge"] },
  { h3: "Maintenance et petits travaux", to: "/petits-travaux-brest/", items: ["Petite réparation", "Montage de meuble", "Retouche de peinture", "Entretien extérieur", "Coordination d'un artisan"] },
];

export default function Tarifs() {
  usePageMeta("Tarifs conciergerie à Brest – formules et prestations", "Tarifs de la Conciergerie Familly 29 à Brest : formules d'abonnement, formule militaire et prestations à la carte sur devis gratuit.");
  const { data = [], isLoading } = useQuery({ queryKey: ["formules"], queryFn: () => api.get("/public/formules").then((r) => r.data) });
  return (
    <>
      <PageHero testid="tarifs-hero" eyebrow="Tarifs" title="Tarifs de conciergerie à Brest" text="Des formules claires pour les absences régulières et des prestations à la carte sur devis gratuit." image="/images/maison.jpg" />
      <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8" data-testid="tarifs-page">
        <h2 className="font-display text-2xl font-semibold md:text-3xl">Nos formules d'abonnement</h2>
        <p className="mt-3 max-w-2xl text-slate-600">Sans durée imposée sauf mention contraire au devis, résiliables en ligne avec un préavis de trente jours.</p>
        {isLoading ? <p className="mt-8 text-sm text-slate-500">Chargement…</p> : (
          <div className="mt-8 grid gap-6 md:grid-cols-3" data-testid="tarifs-formules">
            {data.map((f, i) => <Reveal key={f.id} delay={i * 0.06}><FormuleCard f={f} /></Reveal>)}
          </div>
        )}
        <p className="mt-6 text-xs text-slate-500">Prix en euros. TVA non applicable, art. L. 223 et s. du CIBS (franchise en base). Le contenu exact et le prix définitif figurent sur votre devis – voir nos <Link to="/cgv" className="underline">CGV</Link>.</p>
        <h2 className="mt-20 font-display text-2xl font-semibold md:text-3xl">Prestations à la carte</h2>
        <p className="mt-3 max-w-2xl text-slate-600">Le prix dépend de la surface, de l'accès et du temps nécessaire : chaque prestation fait l'objet d'un devis gratuit avant intervention.</p>
        <div className="mt-8 grid gap-6 md:grid-cols-2" data-testid="tarifs-catalogue">
          {CATALOGUE.map((c) => (
            <div key={c.h3} className="rounded-lg border border-[#0F2840]/10 p-6">
              <h3 className="font-display text-xl font-semibold"><Link to={c.to} className="hover:text-[#D82C2C]">{c.h3}</Link></h3>
              <ul className="mt-4 divide-y text-sm">
                {c.items.map((x) => (
                  <li key={x} className="flex items-center justify-between gap-3 py-2.5">
                    <span>{x}</span>
                    <Link to={`/devis?prestation=${encodeURIComponent(x)}&categorie=${encodeURIComponent(c.to)}`} className="shrink-0 text-xs font-bold text-[#D82C2C] hover:underline" data-testid={`tarif-devis-${c.to.split('/')[1]}-${c.items.indexOf(x)}`}>Sur devis →</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14"><CtaButtons id="tarifs" /></div>
      </section>
    </>
  );
}
